import React from 'react'
import SeccesReportImg from '../Icons/Subtract.png'
import { useNavigate } from 'react-router-dom'; 

const  Reportsubmited = ({ email, password }) => {

  const navigate = useNavigate()

  return (
    <div className='report-succes'>
      <img src={SeccesReportImg} alt="" />
      <h1>You have successfully submitted your report!</h1>
      <div className="reporter-information">
        <p className='reporterinfo'>E-mail <span>{email}</span></p>
        <p className='reporterinfo'>Password <span>{password}</span></p>
      </div>
      <div className="content-text">Please store these credentials in a safe place.</div>
      <div className='back-next'>
        <button className='Nextbtn' onClick={() => navigate('/')}>To the homepage</button>
      </div>
    </div>
  )
}

export default Reportsubmited